import type {
  LandingClosingContent,
  LandingHeroContent,
  LandingMetaContent,
} from "../types";

// Lifted verbatim from Hero.tsx / ClosingCTA.tsx / data.ts. No rewording: the
// English render must be byte-identical across this extraction.
export const landingMeta: LandingMetaContent = {
  title: "Flex Fund — MT5 Prop Firm | Weekly Payouts, 90% Split",
  description:
    "Flex Fund is a MetaTrader 5 prop firm — get funded capital, raw spreads, up to 90% profit split, and weekly payouts. Pass once, trade live.",
};

export const landingHero: LandingHeroContent = {
  headline: {
    line1: "Funded capital.",
    line2: "Raw spreads.",
    line3Highlight: "Weekly payouts.",
  },
  lede: "Flex Fund gives serious traders funded capital, raw spreads and industry-leading splits. Pass once, trade live, withdraw weekly.",
  ctaSecondary: "See how it works",
  ticket: {
    sampleEvaluation: "SAMPLE EVALUATION",
    twoStep: "2-STEP",
    from: "FROM",
    accountSize: "ACCOUNT SIZE",
    rows: {
      oneTimeFee: "ONE-TIME FEE",
      profitTarget: "PROFIT TARGET",
      profitSplit: "PROFIT SPLIT",
      leverage: "LEVERAGE",
      timeLimit: "TIME LIMIT",
      payoutCycle: "PAYOUT CYCLE",
    },
    values: {
      noTimeLimit: "NONE",
      weekly: "WEEKLY",
    },
    configureYourOwn: "Configure your own",
  },
  stats: {
    fastPayouts: { display: "FAST PAYOUTS", label: "Delivered weekly" },
    profitSplitBase: { label: "Profit split base" },
    payoutCycleDays: { label: "Day payout cycle" },
  },
};

export const landingClosing: LandingClosingContent = {
  headlineLead: "Ready to ",
  headlineHighlight: "get funded?",
  body: "Pass the evaluation once, then trade live capital — up to 90% profit split, weekly payouts, and institutional MetaTrader 5 execution.",
  ctaSecondary: "How it works",
};
